export function OutlineImagesIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6354 15.4473C20.3523 15.7833 19.9252 15.9992 19.4549 15.9992H12.4536L13.7877 14.0365L16.7341 9.71289L20.6402 15.4473H20.6354Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7878 14.0368L12.4538 15.9994H8.56683C8.13015 15.9994 7.73665 15.8171 7.44873 15.5196L11.2877 11.2871L13.783 14.0368H13.7878Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0098 6.56918V14.4295C21.0098 14.8182 20.8658 15.1733 20.6355 15.4468L16.7294 9.71233L13.7829 14.036L11.2876 11.2863L7.44865 15.5188C7.17992 15.2404 7.01196 14.8566 7.01196 14.4295V6.56918C7.01196 5.70541 7.70778 5 8.56674 5H19.4598C20.314 5 21.0146 5.70541 21.0146 6.56918H21.0098Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.01465 10.998V17.9994C3.01465 19.1031 3.90721 19.9956 5.01091 19.9956H16.0096"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
